<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="partner.title"
                            label="Название"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.legal_entity"
                            label="Юр. лицо"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.individual_taxpayer_number"
                            label="ИНН"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.contract_id"
                            label="№ договора"
                            :horizontal="true"
                        />
                        <CRow class="mb-3">
                            <CCol cols="12" md="3"> Дата договора: </CCol>
                            <CCol
                                cols="12"
                                md="9"
                                class="pl-2">
                                <DatePicker
                                    v-model="datepicker.date"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                        </CRow>
                        <PartnerSignersUpdate :signers="partner.signers" @set-signers="setSigners" />
                        <CInput
                            v-model="partner.commission"
                            label="Комиссия VIP MIRCITY (%)"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.commission_sum"
                            label="Комиссия VIP MIRCITY (руб)"
                            :horizontal="true"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить партнера? Это действие нельзя будет
                        отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deletePartner"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/VipPartnersTabLinks';
    import PartnerSignersUpdate from '@/components/partner/PartnerSignersUpdate';
    import PartnerReportSettings from '@/components/partner/PartnerReportSettings';
    import { PAYMENT_TYPE } from '../../utils/payment';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';

    export default {

        name: 'PartnerEdit',
        components: {
            PartnersTabLinks,
            PartnerSignersUpdate,
            PartnerReportSettings,
            DatePicker
        },

        data() {
            return {
                partner: {
                    id: 0,
                    title: '',
                    payment: 1,
                    telegram_chat_id: '',
                    contract_id: '',
                    contract_date: '',
                    notification_delay: null,
                    try_count: null,
                    commission: 0,
                    commission_sum: 0,
                    use_product_vat: false,
                    enabled: false,
                    partnerTelegramUser: null
                },
                telegramUsers: [],
                signers: [],
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    date: null,
                },
                deleteModal: false,
                addUser: true,
                userPhone: null,
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
            };
        },

        computed: { 
            paymentTypeOptions() {
                const options = [];
                for (const key in PAYMENT_TYPE) {
                    options.push({
                        value: PAYMENT_TYPE[key],
                        label: paymentTypeTitle(PAYMENT_TYPE[key]),
                    });
                }
                return options;
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/vip-partners/' + id)
                    .then(resp => {
                        const partner = resp.data;
                        delete partner.restaurants;
                        delete partner.grocers;
                        this.partner = resp.data;
                        this.datepicker.date = moment(resp.data.contract_date).format('YYYY.MM.DD');
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });

                // Vue.axios.get('/vip-partners/telegram-users/' + id)
                //     .then(resp => {
                //         this.telegramUsers = resp.data;
                //     })
                //     .catch(() => {
                //         this.$root.$emit('showError', 'Ошибка загрузки данных.');
                //     });
            },

            save() {
                if (this.partner.notification_delay && !this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните макс. кол-во уведомлений!');
                    return;
                }
                if (this?.partner?.notification_delay && this?.partner?.notification_delay < 20) {
                    this.$root.$emit('showError', 'Задержка повтора уведомлений не может быть меньше чем 20 сек.');
                    return;
                }
                if (!this.partner.notification_delay && this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните задержку повтора уведомлений!');
                    return;
                }
                this.partner.contract_date = moment(this.datepicker.date).format('YYYY-MM-DD');
                this.partner.commission = this.partner.commission ? +this.partner.commission : null;
                this.partner.commission_sum = this.partner.commission_sum ? +this.partner.commission_sum : null;
                this.partner.notification_delay = this.partner.notification_delay ? +this.partner.notification_delay : null;
                this.partner.try_count = this.partner.try_count ? +this.partner.try_count : null;
                Vue.axios
                    .put('/vip-partners/' + this.partner.id, this.partner)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });

                Vue.axios
                    .post(`/vip-partners/${this.partner.id}/signers`, this.signers)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            deletePartner() {
                Vue.axios
                    .delete('/vip-partners/' + this.partner.id)
                    .then(() => {
                        this.$router.push({ path: '/vip-partners' });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            deleteTelegramUser() {
                // Vue.axios
                //     .delete(`/vip-partners/telegram-users/${this.partner.partnerTelegramUser.id}`)
                //     .then(() => {
                //         return this.fetch();
                //     })
                //     .catch(err => {
                //         this.$root.$emit('showError', 'Ошибка удаления.');
                //     });
            },

            createTelegramUser() {
                // Vue.axios
                //     .post('/vip-partners/telegram-users', {
                //         partner_id: this.partner.id,
                //         phone: this.userPhone
                //     })  
                //     .then(() => {
                //         return this.fetch();
                //     })
                //     .catch(err => {
                //         this.$root.$emit('showError', 'Телеграм пользователь с таким номером не ожидает подключения к партнеру.');
                //     });

                //     this.userPhone = '';
            },

            setSigners(signers) {
                this.signers = signers.map(signer => ({ ...signer, partner_id: this.partner.id }));
            },

            setReportFrequency(frequency) {
                this.partner.report_frequency = frequency;
            },
            setReportEmails(emails) {
                this.partner.report_emails = emails;
            },

            goBack() {
                this.$router.push({ path: '/vip-partners/' + this.partner.id });
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
  padding: 7px;
  border-radius: 4px;
}

.handle {
  cursor: pointer;
}
</style>
